/* RESPONSIBLE TEAM: team-inbox-experience */
import type CompanySummary from 'embercom/objects/inbox/company-summary';
import type GeoipData from 'embercom/objects/inbox/geoip-data';

import UserSummary, { type Role, type UserSummaryWireFormat } from './user-summary';

export interface ParticipantUserSummaryWireFormat extends UserSummaryWireFormat {
  added_at?: string;
}

export default class ParticipantUserSummary extends UserSummary {
  readonly addedAt?: Date;

  constructor(
    id: string,
    email?: string,
    name?: string,
    companyIds?: Array<string>,
    company?: CompanySummary,
    companies?: Array<CompanySummary>,
    geoipData?: GeoipData,
    mergedIntoId?: string,
    role?: Role,
    imageURL?: string,
    userId?: string,
    pseudonym?: string,
    phone?: string,
    phoneCountry?: string,
    slackEmail?: string,
    addedAt?: Date,
    phoneMasked?: boolean,
    emailMasked?: boolean,
  ) {
    super(
      id,
      email,
      name,
      companyIds,
      company,
      companies,
      geoipData,
      mergedIntoId,
      role,
      imageURL,
      userId,
      pseudonym,
      phone,
      phoneCountry,
      slackEmail,
      undefined, // sdkSupportsTicket
      phoneMasked,
      emailMasked,
    );

    this.addedAt = addedAt;
  }

  static deserialize(json: ParticipantUserSummaryWireFormat): ParticipantUserSummary {
    let userSummary = super.deserialize(json);

    return new ParticipantUserSummary(
      userSummary.id,
      userSummary.email,
      userSummary.name,
      userSummary.companyIds,
      userSummary.company,
      userSummary.companies,
      userSummary.geoipData,
      userSummary.mergedIntoId,
      userSummary.role,
      userSummary.imageURL,
      userSummary.userId,
      userSummary.pseudonym,
      userSummary.phone,
      userSummary.phoneCountry,
      userSummary.slackEmail,
      json.added_at ? new Date(json.added_at) : undefined,
      userSummary.phoneMasked,
      userSummary.emailMasked,
    );
  }
}

export function firstConversationParticipant(
  participantSummaries: ParticipantUserSummary[],
): ParticipantUserSummary | undefined {
  if (!participantSummaries.length) {
    return undefined;
  }

  let [firstParticipant] = participantSummaries.sortBy('addedAt');
  return firstParticipant;
}
